import { render, staticRenderFns } from "./contactIcon.vue?vue&type=template&id=5c45d8b7&"
import script from "./contactIcon.vue?vue&type=script&lang=js&"
export * from "./contactIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports